function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInterfaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Interfaces",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 10758"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3250",
    d: "M3.078 2.25a.828.828 0 1 0 .828.828.829.829 0 0 0-.828-.828",
    transform: "translate(3.917 4.921)",
    style: {
      fill: "#3a4043"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3251",
    d: "M9.078 2.25a.828.828 0 1 0 .828.828.829.829 0 0 0-.828-.828",
    transform: "translate(3.439 4.921)",
    style: {
      fill: "#3a4043"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3252",
    d: "M6.078 2.25a.828.828 0 1 0 .828.828.829.829 0 0 0-.828-.828",
    transform: "translate(3.678 4.921)",
    style: {
      fill: "#3a4043"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vereinigungsmenge 81",
    d: "M20578.08 22826.91a2.079 2.079 0 0 1-2.078-2.08v-9.75a2.079 2.079 0 0 1 2.078-2.08h11.039a2.083 2.083 0 0 1 2.08 2.08v9.75a2.083 2.083 0 0 1-2.08 2.08zm-.682-2.08a.684.684 0 0 0 .682.682h11.039a.684.684 0 0 0 .684-.682v-5.723h-12.4zm0-9.75v2.537h12.4v-2.537a.68.68 0 0 0-.684-.682h-11.039a.68.68 0 0 0-.675.682z",
    transform: "translate(-20572.003 -22807.999)",
    style: {
      fill: "#3a4043"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterfaces);
export default __webpack_public_path__ + "static/media/IconInterfaces.0c1855e73e15dffca1d98c4fd3778de5.svg";
export { ForwardRef as ReactComponent };